import { createApi } from '@/services/api.service';

class AdminService {
    private api = createApi('admin'); // Creates /api/v2/admin base

    async fetchAdmin() {
        return this.api.get('/profile');
    }

    async fetchExperts(params: Record<string, any>) {
        const queryString = new URLSearchParams(params).toString();
        return this.api.get(`/listings?${queryString}`);
    }

    async fetchExpertFilterOptions() {
        return this.api.get('/filter-options');
    }

    // NEW EXPERT ENDPOINTS (using experts table)
    async fetchNewExperts(params: Record<string, any>) {
        const queryString = new URLSearchParams(params).toString();
        return this.api.get(`/expert-manager?${queryString}`);
    }

    async fetchNewExpertFilterOptions() {
        return this.api.get('/expert-manager/filter-options');
    }

    async activateNewExpertApplication(expertId: number) {
        return this.api.post(`/expert-manager/${expertId}/activate-application`, {});
    }

    async updateNewExpertStatus(expertId: number, action: string) {
        return this.api.post(`/expert-manager/${expertId}/status`, { 
            action
        });
    }

    async resendExpertActivation(expertId: number) {
        return this.api.post(`/expert-manager/${expertId}/resend-activation`, {});
    }

    async loginAsUser(userId: number) {
        return this.api.post(`/login-as/${userId}`, {});
    }

    async updateExpertStatus(expertId: number, action: string) {
        return this.api.post(`/listings/${expertId}/status`, { 
            action
        });
    }

    async updateExpertStatusAndRefresh(expertId: number, action: string, currentFilters: Record<string, any> = {}) {
        return this.api.post(`/listings/${expertId}/status`, { 
            action,
            ...currentFilters 
        });
    }

    async fetchClients(params: Record<string, any>) {
        const queryString = new URLSearchParams(params).toString();
        return this.api.get(`/clients?${queryString}`);
    }

    async fetchClientFilterOptions() {
        return this.api.get(`/clients/filter-options`);
    }
}

export default new AdminService();
